//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'StarRatings',
  props: {
    rating: {
      type: Number,
      default: 5
    },
    crossSellMode: { type: Boolean, default: false },
    reviewMode: { type: Boolean, default: false },
    headerMode: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    size: {
      type: String,
      default: '',
      validator: str => ['', 'sm', 'md', 'lg', 'xl'].includes(str)
    }
  },
  computed: {
    stars () {
      return [...Array(5)].map((_, idx) => Math.min(Math.max(this.rating - idx, 0), 1))
    }
  }
}
